
__webpack_require__.remotesLoadingData = { chunkMapping: {"37":["444"]}, moduleIdToRemoteDataMapping: {"444":{"shareScope":"default","name":"./PromoCard","externalModuleId":2044,"remoteName":"angular_rsbuild_remote"}} };
__webpack_require__.f.remotes = __webpack_require__.f.remotes || function() { throw new Error("should have __webpack_require__.f.remotes"); }
